import { FORMAT_SUPPORT, type ImageFormat } from '@/core/image/formats'
import { SourcePixelBudget, type SourcePixelLimit } from '@/core/image/limits'

export class UnsupportedFormatError extends Error {
  constructor(format: ImageFormat) {
    const support = FORMAT_SUPPORT[format]
    if (!support.hint) throw new Error(`Unsupported format "${format}" is missing its required hint`)
    super(`${support.label} files are not supported. ${support.hint}`)
    this.name = 'UnsupportedFormatError'
  }
}

export class ImageTooLargeError extends Error {
  constructor(actualPixels: number, limit: SourcePixelLimit) {
    const actualMegapixels = (actualPixels / 1_000_000).toFixed(1)
    const maximumMegapixels = (limit.maximumPixels / 1_000_000).toFixed(0)
    const budgetLabel = limit.budget === SourcePixelBudget.LowMemory
      ? 'low-memory device'
      : 'standard device'
    super(`This ${actualMegapixels} MP image exceeds the ${maximumMegapixels} MP ${budgetLabel} limit.`)
    this.name = 'ImageTooLargeError'
  }
}

export class ImageDecodeError extends Error {
  constructor(cause?: unknown) {
    super("We couldn't read this file as an image. It may be damaged or unsupported by this browser.", {
      cause,
    })
    this.name = 'ImageDecodeError'
  }
}
